import { styled } from 'styled-components';
export const Meta = styled.div `
  margin-bottom: 20px;
  text-align: left;
  width: 500px;
`;
//# sourceMappingURL=style.js.map